// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

// const routes = [{
// 	name: 'app',
// 	path: '/app',
// 	redirect: '/app/nyzn',
// 	meta: {
// 		title: '能源智能分析系统',
// 		noCache: true
// 	},
// 	component: () => import("../views/znnyFxSys/index.vue"),
// 	children: [{
// 			name: 'nyzn',
// 			path: '/app/nyzn',
// 			meta: {
// 				title: '能源智能分析系统',
// 				noCache: true
// 			},
// 			noCache: true,
// 			component: () => import('../views/znnyFxSys/index.vue')
// 		},
// 		{
// 			name: 'sjzx',
// 			path: '/app/sjzx',
// 			meta: {
// 				title: '数据中心大屏看板系统',
// 				noCache: true
// 			},
// 			component: () => import('../views/dataCenterSys/index.vue')
// 		}
// 	]
// }]
// const router = new VueRouter({
// 	mode: "history",
// 	routes
// })
// router.beforeEach((to, from, next) => {
// 	//beforeEach是router的钩子函数，在进入路由前执行
// 	if (to.meta.title) {
// 		//判断是否有标题
// 		// console.log(to.meta.title)
// 		document.title = to.meta.title
// 	} else {
// 		document.title = '能源智能分析系统'
// 	}
// 	next()
// })

// export default router



import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
		path: '/nyzn',
		meta: {
			title: '地图数据',
			noCache: true
		},
		name: 'nyzn',
		component: () => import("../views/mapData/index.vue")
	},{
		path: '/kb',
		meta: {
			title: '腾冲市投资促进局招商地图',
			noCache: true
		},
		name: 'kb',
		component: () => import("../views/mapData/index3.vue")
	},{
		path: '/zszy',
		meta: {
			title: '腾冲市投资促进局招商地图',
			noCache: true
		},
		name: 'zszy',
		component: () => import("../views/mapData/provincialZszy.vue")
	},{
		path: '/zszySf',
		meta: {
			title: '腾冲市投资促进局招商地图',
			noCache: true
		},
		name: 'zszySf',
		component: () => import("../views/mapData/countyZszy.vue")
	},{
		path: '/',
		meta: {
			title: '腾冲市投资促进局招商地图',
			noCache: true
		},
		name: 'bfjl',
		component: () => import("../views/mapData/provincialBfjl.vue")
	},{
		path: '/bfjlSf',
		meta: {
			title: '腾冲市投资促进局招商地图',
			noCache: true
		},
		name: 'bfjlSf',
		component: () => import("../views/mapData/countyBfjl.vue")
	}]
const router = new VueRouter({
	mode: "history",
	routes
})
router.beforeEach((to, from, next) => {
	//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {
		//判断是否有标题
		// console.log(to.meta.title)
		document.title = to.meta.title
	} else {
		document.title = '能源智能分析系统'
	}
	next()
})
export default router
